import { GridColDef } from "@mui/x-data-grid";
import { Box, Chip } from "@mui/material";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { BugReport } from "@mui/icons-material";
import { JOB_ISSUES_ENDPOINT } from "../../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../../contexts/auth";
import { getContrastColor } from "../../../utils";

export default function JobIssuesList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewJobIssues = useHasPermission("service.view_jobissue");

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: t("Title"),
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        const title = params.row.title || "—";
        const code = params.row.code as string | null | undefined;
        const label = code ? `${title} (${code})` : title;
        const color = params.row.color as string | null | undefined;
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Chip
              label={label}
              size="small"
              sx={
                color
                  ? {
                      bgcolor: color,
                      color: getContrastColor(color),
                      "& .MuiChip-label": { color: getContrastColor(color) },
                    }
                  : {
                      bgcolor: "rgba(128, 128, 128, 0.25)",
                      color: "text.secondary",
                    }
              }
            />
          </Box>
        );
      },
    },
    {
      field: "code",
      headerName: t("Code"),
      width: 100,
      valueGetter: (value, row) => row.code || "—",
    },
    {
      field: "description",
      headerName: t("Description"),
      valueGetter: (value, row) => row.description || "—",
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/service/issues-catalog/${id}`);
  };

  if (!canViewJobIssues) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<BugReport />}
      title={t("Issues Catalog")}
      url={JOB_ISSUES_ENDPOINT}
      gridSettingsKey="JOB_ISSUES_CATALOG"
      columns={columns}
      refreshEventName="jobIssueAdded"
      onRowClick={handleRowClick}
    />
  );
}
